module.exports = __webpack_public_path__ + "static/fonts/342F4F_F_0.4e29d00.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/342F4F_F_0.ttf
// module id = 112
// module chunks = 3